import { RemoteLoadWorkList } from '@/javascript/data/usecases'
import { LoadWorkList } from '@/javascript/domain/usecases'
import { makeCurrentAccountHttpClientDecorator } from '@/javascript/main/factories/decorators'
import { makeApiUrl } from '../http'

export const makeRemoteLoadWorkList = (): LoadWorkList =>
  new RemoteLoadWorkList(makeApiUrl('/works/minified'), makeCurrentAccountHttpClientDecorator())
